import { createContext, PropsWithChildren, useContext } from 'react';

import { once } from 'lodash';

import { AssetsStore } from '../../pages/Assets/store';

export interface AssetsTableProps {
  assetsTableCtx: AssetsStore;
}

export const createAssetsTableCtx = once(() =>
  createContext<AssetsTableProps | undefined>(undefined),
);

const AssetsContext = createAssetsTableCtx();
export const AssetsProvider = ({
  children,
  assetsTableCtx,
}: PropsWithChildren<AssetsTableProps>) => {
  return (
    <AssetsContext.Provider value={{ assetsTableCtx }}>
      {children}
    </AssetsContext.Provider>
  );
};

/* Hook to use store in any functional component */
export const useAssetsStore = () => {
  const context = useContext(createAssetsTableCtx());

  if (!context) {
    throw new Error('useAssetsStore must be used within a AssetsProvider');
  }

  return context.assetsTableCtx;
};
